"use strict";
/**
 *
 * transition
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEasing = {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};
exports.defaultDuration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195,
};
exports.formatMs = (milliseconds) => `${Math.round(milliseconds)}ms`;
exports.defaultTransition = {
    easing: exports.defaultEasing,
    duration: exports.defaultDuration,
    create: (props, options = {}) => {
        const { duration = exports.defaultDuration.standard, easing = exports.defaultEasing.easeInOut, delay = 0, } = options;
        return (Array.isArray(props) ? props : [props])
            .map((animatedProp) => `${animatedProp} ${typeof duration === 'string' ? duration : exports.formatMs(duration)} ${easing} ${typeof delay === 'string' ? delay : exports.formatMs(delay)}`)
            .join(',');
    },
    getAutoHeightDuration(height) {
        if (!height) {
            return 0;
        }
        const constant = height / 36;
        // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    },
};
exports.reflow = (node) => node.scrollTop;
function getTransitionProps(props, options) {
    const { timeout = {}, style = {} } = props;
    return {
        duration: style.transitionDuration || typeof timeout === 'number'
            ? timeout
            : timeout[options.mode] || 0,
        delay: style.transitionDelay,
    };
}
exports.getTransitionProps = getTransitionProps;
